import * as React from 'react';
import classNames from 'classnames';

import * as style from './TableCell.css';
import { getCellStyle } from '../../../../utils/table';

export interface ITableCellProps {
  dragging?: boolean;
  fullWidth?: boolean;
  position?: number;
}

export const TableCell: React.FC<React.PropsWithChildren<ITableCellProps>> = props => {
  const { dragging, children, fullWidth, position } = props;
  const colspan = fullWidth ? 1000 : undefined;
  const styles = React.useMemo(() => getCellStyle(position), [position]);

  const cellStyles = React.useMemo(
    () =>
      classNames(style['cell'], {
        [style['cell--fullwidth']]: fullWidth,
        [style['cell--dragging']]: dragging,
      }),
    [fullWidth, dragging],
  );

  return (
    <td style={styles} colSpan={colspan} className={cellStyles}>
      {children}
    </td>
  );
};
